import { useState } from "react";
import iconStackOfCoins from "../../assets/home-page/hero-loan-calculator/icon-stack-of-coins.svg";
import iconClock from "../../assets/home-page/hero-loan-calculator/icon-clock.svg";
import iconArrowRight from "../../assets/home-page/hero-loan-calculator/icon-arrow-right.svg";
import { siteConfig } from "../../config/site";

const MIN = 10000;
const MAX = 100000;

function formatInr(value: number) {
  return `₹${value.toLocaleString("en-IN")}`;
}

export function HeroLoanCalculator() {
  const [amount, setAmount] = useState(50000);
  const percent = ((amount - MIN) / (MAX - MIN)) * 100;

  return (
    <div className="reveal reveal-5 mx-auto flex w-full max-w-[634px] flex-col gap-4 rounded-2xl border border-solid border-[rgba(226,232,240,0.8)] bg-[#f9fafd] p-[29px]">
      {/* Row 1: header */}
      <div className="flex flex-col items-start justify-between gap-3 pb-2 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white shadow-[0px_1px_1px_rgba(0,0,0,0.05)]">
            <img src={iconStackOfCoins} alt="" className="h-7 w-6" />
          </div>
          <h3 className="text-xl font-bold leading-7 text-[#3e025c]">
            Choose your loan amount
          </h3>
        </div>
        <span className="text-sm leading-5 text-[#64748b]">
          Move the slider and see your options.
        </span>
      </div>

      {/* Row 2: amount + slider */}
      <div className="flex flex-col items-center justify-center pb-2">
        <p className="pb-4 text-4xl font-extrabold tracking-[-0.9px] text-[#3e025c]">
          {formatInr(amount)}
        </p>

        <div className="flex w-full max-w-[576px] items-center gap-4">
          <span className="shrink-0 text-[15px] font-semibold leading-4 text-[#64748b]">
            ₹10,000
          </span>
          <div className="relative flex h-6 flex-1 items-center">
            <input
              type="range"
              min={MIN}
              max={MAX}
              step={1000}
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
              className="range-slider h-2 w-full cursor-pointer appearance-none rounded-full bg-[#e2e8f0]"
              style={{
                background: `linear-gradient(to right, #3e025c ${percent}%, #e2e8f0 ${percent}%)`,
              }}
            />
          </div>
          <span className="shrink-0 text-[15px] font-semibold leading-4 text-[#64748b]">
            ₹1,00,000
          </span>
        </div>
      </div>

      {/* Row 3: helper + CTA */}
      <div className="flex flex-col items-stretch justify-between gap-4 border-t border-solid border-[rgba(226,232,240,0.6)] pt-[9px] sm:flex-row sm:items-center">
        <div className="flex items-center gap-2">
          <img src={iconClock} alt="" className="h-4 w-4" />
          <span className="text-sm leading-5 text-[#475569]">
            Get personalized loan options in minutes.
          </span>
        </div>
        <a
          href={siteConfig.applyLink || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 rounded-full bg-[#176766] px-7 py-[14px] text-base font-bold text-white shadow-[0px_4px_7px_rgba(23,103,102,0.25)] transition-colors hover:bg-[#125150]"
        >
          Check My Options
          <img src={iconArrowRight} alt="" className="h-4 w-4" />
        </a>
      </div>

      <style>{`
        .range-slider::-webkit-slider-thumb {
          appearance: none;
          width: 32px;
          height: 32px;
          border-radius: 9999px;
          background: white;
          border: 4px solid #3e025c;
          box-shadow: 0px 4px 6px -1px rgba(0,0,0,0.1), 0px 2px 4px -2px rgba(0,0,0,0.1);
          cursor: grab;
        }
        .range-slider::-moz-range-thumb {
          width: 32px;
          height: 32px;
          border-radius: 9999px;
          background: white;
          border: 4px solid #3e025c;
          box-shadow: 0px 4px 6px -1px rgba(0,0,0,0.1), 0px 2px 4px -2px rgba(0,0,0,0.1);
          cursor: grab;
        }
      `}</style>
    </div>
  );
}
